// State/Empty (Figma 21:26). A 560px panel, centred, on a DASHED
// --border-strong stroke — the dashed edge is the empty-state signal.
//
// Frames 09 (33:2743, "no second doc yet") and 12 (33:393, "corpus too
// small") are both instances of this one component, so both must be
// expressible here without either screen inventing a bespoke variant.
//
// The Figma component doc explains why the copy slots matter: "copy is
// deliberately instructional — the graph views show a single-doc customer
// nothing on day one, and a blank hero panel loses the account." An empty
// state with no `body` is a missed sale, not a tidy screen.

import "./ui.css";
import type { ReactNode } from "react";
import { Icon } from "./Icon";
import type { IconName } from "./Icon";

export type EmptyStateProps = {
  headline: string;
  body?: ReactNode;
  /** Usually a primary <Button>. */
  action?: ReactNode;
  icon?: IconName;
};

export function EmptyState({
  headline,
  body,
  action,
  icon = "bar-chart",
}: EmptyStateProps) {
  return (
    <div className="maisight-ui-state" data-kind="empty">
      <span className="maisight-ui-state-icon">
        <Icon name={icon} size={24} />
      </span>
      <h2 className="maisight-ui-state-headline type-h2">{headline}</h2>
      {body ? <p className="maisight-ui-state-body type-bodyS">{body}</p> : null}
      {action ? <div className="maisight-ui-state-action">{action}</div> : null}
    </div>
  );
}
